import React from 'react';

const ACTION_WORDS = new Set(['added', 'removed', 'updated', 'changed']);

const ACTION_CLASS = {
    added: 'oh-detail-added',
    removed: 'oh-detail-removed',
    updated: 'oh-detail-updated',
    changed: 'oh-detail-changed',
};

const HistoryDetailsCell = ({ text }) => {
    if (!text || text === '—') return <span>—</span>;

    const parts = text.split(/\b(added|removed|updated|changed)\b/gi);

    return (
        <span>
            {parts.map((part, index) => {
                const key = ACTION_WORDS.has(part.toLowerCase()) ? part.toLowerCase() : null;
                if (key) {
                    return (
                        <span key={index} className={`oh-detail-action ${ACTION_CLASS[key]}`}>
                            {part}
                        </span>
                    );
                }
                return <React.Fragment key={index}>{part}</React.Fragment>;
            })}
        </span>
    );
};

export default HistoryDetailsCell;
